module.exports = __webpack_public_path__ + "img/ccm.f5e14c92.jpg";